<template>
<div class="InstallRecordContainer">
  <div class="query">
    <span>
      <!-- <el-input placeholder="请输入关键字" autocomplete="off" v-model="keyWords.key" style="width:200px;"></el-input> -->
      <el-select v-model="keyWords.type" placeholder="操作类型" style="padding: 5px 0" clearable>
        <el-option label="拆卸" :value="1"></el-option>
        <el-option label="安装" :value="0"></el-option>
      </el-select>
    </span>
    <!-- <button class="primaryBtn" @click="searchData">查询</button> -->
    <el-button
      class="common"
      type="primary"
      size="medium"
      @click="searchData"
      icon="el-icon-search">查询</el-button>
  </div>
  <border-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @currentChange="gasCurrentChange" @sizeChange="gasSizeChange">
    <el-table-column type="index" label="#" width="60"></el-table-column>
    <el-table-column prop="id" label="操作类型" show-overflow-tooltip>
      <template slot-scope="scope">
        <span v-if="!scope.row.type" style="color:#00b050">安装</span>
        <span style="color:#ff0000" v-else>拆卸</span>
      </template>
    </el-table-column>
    <el-table-column prop="isTenantInstall" label="是否租户操作">
      <template slot-scope="scope">
        <span v-if="scope.row.isTenantInstall" style="color:#00b050">是</span>
        <span style="color:#ff0000" v-else>否</span>
      </template>
    </el-table-column>
    <el-table-column prop="nickName" label="操作者">
      <template slot-scope="scope">
        <span v-if="scope.row.isTenantInstall">{{scope.row.tnickName}}</span>
        <span v-else>{{scope.row.unickName}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="installLocation" label="安装位置" show-overflow-tooltip></el-table-column>
    <el-table-column prop="createTime" label="操作时间" show-overflow-tooltip></el-table-column>
    <el-table-column prop="useTime" label="使用时长（s）" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{scope.row.useTime?scope.row.useTime:'暂无'}}</span>
      </template>
    </el-table-column>
  </border-table>
</div>
</template>

<script>
import BorderTable from "@/views/deviceManagement/deviceDetails/BorderTable";
export default {
  components: {
    BorderTable
  },
  props: {
    deviceId: {
      type: Number,
      default: () => {
        return null;
      }
    }
  },
  data() {
    return {
      searchText: '',
      keyWords: {
        type: "",
        key: ""
      },
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      tableLoading: false,
      dataList: [],
      deviceTypeList: []
    }
  },
  created() {
    // this.getDeviceType()
    this.reloadTable()
  },
  methods: {
    getDeviceType() {
      this.request.post('/front/device/type/query', {
          page: 1,
          pageSize: 1000
        }).then(res => {
          console.log(res);
          if (res.code === 200) {
            this.deviceTypeList = res.data.data ? res.data.data : []
          } else if (res.code === 500) {
            this.deviceTypeList = []
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    searchData() {
      //查询//查询
      this.keyWords.key = this.keyWords.key.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1;
      this.reloadTable();
    },
    gasCurrentChange(val) {
      this.pagination.currentPage = val;
      this.reloadTable();
    },
    //表格展示条数变化时
    gasSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.reloadTable();
    },
    reloadTable() {
      this.params = {
        key: this.keyWords.key,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        sort: "createTime",
        order: 'desc',
        deviceId: this.deviceId,
        type: this.keyWords.type
      }
      this.request.post('/front/device/install/record/query', this.params).then(res => {
        if (res.code === 200) {
          this.tableLoading = false
          // console.log(res);
          // let arr = []
          // for(var i=0;i <6;i++){
          //   arr.push(res.data.data[0])
          // }
          // this.dataList = [...arr]
          this.dataList = res.data.data
          this.pagination.total = res.data.totalCount
        } else if (res.code === 500) {
          this.dataList = []
          this.msg.warn(res.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss">
.InstallRecordContainer {
  .query {
    padding-bottom: 15px;

    .primaryBtn {
      width: 82px;
      height: 36px;
      cursor: pointer;
      margin-right: 20px;
      font-size: 14px;
      line-height: 36px;
      border: 0;
      color: #FFFFFF;
      background: #1089FF;
      border-radius: 2px;

      &:hover {
        background: #0774e0;
      }
    }

    .el-input {
      width: 380px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width: 180px;
      margin-right: 10px;

      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-range-editor.el-input__inner {
      height: 36px;
      line-height: 36px;
      padding: 5px 10px;
      margin-right: 10px;
    }
  }
}
</style>
